import { CircleChevronDown } from "lucide-react"
import { useTranslation } from "react-i18next"

interface ScrollToBottomButtonProps {
  onClick: () => void
  bottom: string
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  onClick,
  bottom,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className="via-white/20 absolute flex h-24 w-full items-center justify-center bg-gradient-to-b from-transparent from-0% via-70% to-white to-100%"
      style={{
        bottom: bottom,
      }}
    >
      <div
        className={
          "flex h-10 items-center justify-center gap-4 rounded-full border border-neutral-500 bg-white p-1 px-4 text-neutral-600 shadow-md"
        }
        onClick={onClick}
      >
        <p className={"text-neutral-600"}>{t("lastMessage")}</p>
        <CircleChevronDown strokeWidth={1} />
      </div>
    </div>
  )
}

export default ScrollToBottomButton
